import { render, staticRenderFns } from "./menu-block.vue?vue&type=template&id=e8c8a26e&scoped=true"
import script from "./menu-block.vue?vue&type=script&lang=js"
export * from "./menu-block.vue?vue&type=script&lang=js"
import style0 from "./menu-block.vue?vue&type=style&index=0&id=e8c8a26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c8a26e",
  null
  
)

export default component.exports